import React from 'react';
import { Routes, Route } from 'react-router-dom';
/* import ResponsiveAppBar from './views/NavBar';
import ResponsiveFootBar from './views/FootBar'; */
import { Box } from '@mui/material';
import PrivacyPolicy from './views/PrivacyPolicy.js';
import TermsAndConditions from './views/TermsAndConditions.js';
import MarketMonitorCorporate from './views/MarketMonitorCorporate/marketMonitorCorporate.js';
import MarketCompany from './views/MarketMonitorCorporate/marketCompany.js';
import MarketComparativeCorporate from './views/MarketMonitorCorporate/marketComparativeCorporate.js';

const App = () => {

  return (
    <>
      {/* <ResponsiveAppBar /> */}
      <Box sx={{ minHeight: '80vh', display: 'flex', flexDirection: 'column' }}>
        <Routes>
          <Route path='/privacy-policy' element={<PrivacyPolicy />} />
          <Route path='/terms-and-conditions' element={<TermsAndConditions />} />

          {/* Market Monitor Corporate */}
          <Route path="/" element={<MarketMonitorCorporate />} />
          <Route path="/market-monitor-corporate" element={<MarketMonitorCorporate />} />
          {/* slug unico */}
          <Route path="/market-company/:countrySlug/:companySlug" element={<MarketCompany />} />
          <Route path="/market-company/:companySlug" element={<MarketCompany />} />
          {/* slug unico */}
          <Route path="/market-company" element={<MarketCompany />} />
          <Route path="/market-comparative-corporate" element={<MarketComparativeCorporate />}
          />
        </Routes>
      </Box>
      {/* <ResponsiveFootBar /> */}
    </>
  );
};

export default App;
